import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Container, HighlightSelector} from '../../components/@FreeModel/';
import Header from '../../components/general/Header/Header';
import {useDispatch} from "react-redux";
import {gql, updateApplication} from "../../db/model";

const TaxInfo = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()

  const [businessType, setBusinessType] = useState('');

  const isValid = businessType !== ''

  const handleClick = async () => {
    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          businessType,
        }
      },
      onSuccess: (_) => navigate(`/contractors/${applicationID}/tax-info/${businessType.toLowerCase()}`)
    }))
  }

  return (
    <Container>
      <Header title="Add Tax Info" text="Which of the following options best describes your business?"/>
      <br/>
      <br/>

      <HighlightSelector
        title="Individual"
        subtitle="(Sole-proprietor/single-member LLC)"
        text="Choose this if you work under your legal name and you will provide a Social Security Number."
        selected={businessType === 'Individual'}
        onClick={() => setBusinessType('Individual')}
      />

      <HighlightSelector
        title="Business"
        subtitle="(C Corp, S Corp, LLC, Partnership)"
        text="Choose this if your business has a separate name and you have a Employee Identification Number (EIN)."
        selected={businessType === 'Business'}
        onClick={() => setBusinessType('Business')}
      />

      <Button disabled={!isValid} onClick={handleClick}>
        Continue
      </Button>
    </Container>
  );
};

export default TaxInfo;
